export default __webpack_public_path__ + "static/thumb-landscape-262661875bd1054eb91ee7e1452fa3ae.jpg";